import { Link, useLocation } from "react-router-dom";
import useMe from "../hooks/useMe.js";

export default function NavBar(){
  const { me } = useMe();
  const loc = useLocation();
  const isAdmin = (me?.role || "").toString().toUpperCase() === "ADMIN";
  const isDev = !!me?.is_dev;

  const tabs = [
    { to:"/",              label:"Home" },
    { to:"/announcements", label:"Announcements" },
    { to:"/events",        label:"Events" },
    { to:"/ads",           label:"Ads" },
    { to:"/profile",       label:"Profile" },
  ];

  if (isAdmin || isDev) {
    tabs.splice(4, 0, { to:"/admin/users",  label:"Admin" });
    tabs.push({ to:"/admin/system", label:"System" });
    tabs.push({ to:"/admin/events", label:"Admin Events" });
    tabs.push({ to:"/dev/logs",     label:"DEV Logs" });
  }

  return (
    <nav style={{display:"flex",gap:12,padding:"8px 12px",borderBottom:"1px solid #eee",flexWrap:"wrap"}}>
      {tabs.map(t=>(
        <Link key={t.to} to={t.to}
          style={{
            textDecoration:"none",padding:"6px 10px",borderRadius:8,
            background: loc.pathname===t.to ? "#eef2ff" : "transparent", color:"#111"
          }}>
          {t.label}
        </Link>
      ))}
      <span style={{marginLeft:"auto",fontSize:12,opacity:.7}}>
        {me?.email ? `Signed in: ${me.email}${isDev?" (DEV)":""}` : "Not signed in"}
      </span>
    </nav>
  );
}
